import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="max-w-md mx-auto text-center animate-fade-in">
      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="flex justify-center mb-6">
          <div className="bg-accent-100 p-4 rounded-full">
            <AlertTriangle size={48} className="text-accent-600" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-primary-800 mb-4">Page Not Found</h1>
        <p className="text-neutral-600 mb-6">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded-lg shadow transition-colors"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;